import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-bg',
  templateUrl: './mobile-bg.component.html',
  styleUrls: ['./mobile-bg.component.scss']
})
export class MobileBgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
